import { TEST_IDS } from "../testing/testIds";
import styles from "./MetaStrip.module.css";

type Props = {
  label: string;
  onBack?: () => void;
};

export function MetaStrip({ label, onBack }: Props) {
  return (
    <div className={styles.meta}>
      {onBack && (
        <button
          className={styles.backBtn}
          onClick={onBack}
          type="button"
          data-testid={TEST_IDS.BACK_BTN}
        >
          ← back
        </button>
      )}
      <span className={styles.metaLabel}>{label}</span>
    </div>
  );
}
